import Vue from 'vue'
import App from './App.vue'

//路由
import VueRouter from 'vue-router';
Vue.use(VueRouter);                            //安装插件到全局

import routes from './router/router.config';   //路由配置
const router = new VueRouter(routes);

//国际化
import i18n from './utils/i18n'
import ElementUI from 'element-ui';
Vue.use(ElementUI);

import animate from 'animate.css'
Vue.use(animate);


import VueDraggableResizable from 'vue-draggable-resizable'

// optionally import default styles
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

Vue.component('vue-draggable-resizable', VueDraggableResizable)

//交互axios
import axios from 'axios';
Vue.prototype.axios = axios;                   //原型绑定axios

import HttpService from './service/HttpService';     //引入axios配置
Vue.prototype.$http = HttpService;             //原型绑定


//状态管理
import store from './store';

//引入common
import common from './common.js'
Vue.prototype.common = common;

export default new Vue({          //创建根实例
  el: '#app',
  i18n,
  render: h => h(App),
  router,
  store
});



// WEBPACK FOOTER //
// ./src/main.js